import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {FileItem, FileLikeObject, FileUploader} from 'ng2-file-upload';
import {CreateMessageChangeEvent} from './createMessageChangeEvent';
import {MessageCreateWithBusinessContextPayload} from '../../../impl/service/payload/messageCreateWithBusinessContext.payload';
import {BusinessContextModel} from '../../../../common/businesscontext/api/entity/businessContext.model';
import {MessageCreatePayload} from '../../../impl/service/payload/messageCreate.payload';
import {MessageModel} from '../../model/messageModel';
import {MessageSaveService} from '../../../impl/service/messageSave.service';
import {BusinessContextPayload} from '../../../../common/businesscontext/api/payload/businessContext.payload';
import {BaseView} from '../../../../core/view/base.view';
import {RichTextEditorComponent} from '../../../../../components/common/rich-text-editor/rich-text-editor.component';
import {DialogController} from "../../../../common/dialog/dialogController";
import {
  CreateMessageAddAttachmentDialogComponent,
  CreateMessageAddAttachmentDialogInput,
  CreateMessageAddAttachmentDialogOutput
} from "../../../impl/component/create-message-add-attachment-dialog/create-message-add-attachment-dialog.component";
import {BusinessContextSummaryModel} from "../../../../common/businesscontext/api/entity/businessContextSummary.model";

@Component({
  selector: 'app-create-message',
  templateUrl: './create-message.component.html',
  providers: [MessageSaveService]
})
export class CreateMessageComponent extends BaseView implements OnInit {

  addMessageFormGroup: UntypedFormGroup;
  addMessageLoading = false;
  shift = false;

  uploadedFiles: FileLikeObject[] = [];

  // @Input() createMessageProcessor: (content: string, attachments: FileLikeObject[]) => void;
  @Input() businessContext: BusinessContextSummaryModel;
  @Input() compact = false;
  @Output() messageOrAttachmentChangeEvent = new EventEmitter<CreateMessageChangeEvent>();
  @Output() messageAddedEvent = new EventEmitter<MessageModel>();


  constructor(private formBuilder: UntypedFormBuilder,
              public messageSaveService: MessageSaveService,
              private dialogController: DialogController) {
    super();
  }

  ngOnInit() {
    this.addMessageFormGroup = this.formBuilder.group({
      summary: this.formBuilder.group({
        id: this.formBuilder.control(undefined)
      }),
      text: new UntypedFormControl(undefined, Validators.required),
    });
  }

  removeUploadedFile(uploadedFile: FileLikeObject) {
    this.uploadedFiles.splice(this.uploadedFiles.indexOf(uploadedFile), 1);
  }

  addMessage() {
    const payload = this.addMessageFormGroup.value;
    const businessContextPayload = new BusinessContextPayload();
    businessContextPayload.contextName = this.businessContext.name;
    businessContextPayload.entityId = this.businessContext.entityId;

    payload.message = this.messageCreatePayload;
    payload.businessContext = businessContextPayload;
    this.addMessageLoading = true;
    this.messageSaveService.save(payload)
        .then((message) => {
          this.messageAddedEvent?.emit(message);
          this.addMessageFormGroup.reset();
          this.uploadedFiles = [];
        })
        .catch(() => this.toastControl.presentError(undefined, 'Ajout du message impossible'))
        .finally(() => this.addMessageLoading = false);
  }

  get messageCreatePayload(): MessageCreatePayload {
    const messagePayload = new MessageCreatePayload();
    messagePayload.content = this.text;
    messagePayload.attachments = this.uploadedFiles;
    return messagePayload;
  }

  onKeyPressed(key: string) {
    console.log([this.addMessageFormGroup.valid, key === 'Shift', key === 'Enter']);
    if (this.addMessageFormGroup.valid) {
      if (key === 'Shift') {
        this.shift = true;
      } else if (key === 'Enter') {
        if (! this.shift) {
          this.addMessage();
        }
      } else {
        this.shift = false;
      }
    }
  }

  addAttachments() {
    const input: CreateMessageAddAttachmentDialogInput = {
      maxFileCount: 5 - this.uploadedFiles?.length
    }
    this.dialogController.open(CreateMessageAddAttachmentDialogComponent, input, {
      title: 'Joindre des fichiers',
      width: '300px'
    }).afterClosed()
        .toPromise()
        .then((result: CreateMessageAddAttachmentDialogOutput) => {
          if (result) {
            result.uploadedFiles.forEach(value => this.uploadedFiles.push(value));
          }
        })
  }

  get text(): string {
    return this.addMessageFormGroup.controls.text.value
  }

  reset() {
    this.uploadedFiles = [];
    this.addMessageFormGroup.reset();
  }

  set text(value: string) {
    this.addMessageFormGroup.controls.text.setValue(value);
  }

  onContentChanged() {
    this.messageOrAttachmentChangeEvent?.emit(new CreateMessageChangeEvent(this.text, this.uploadedFiles));
  }
}
